export default __webpack_public_path__ + "static/silkserif-light-italic-d721ac91a7c3ec3035c375979d961544.woff";